import { SET_SIDEBAR_STATE } from './types';
export var setSidebarState = function setSidebarState(newState) {
  return {
    type: SET_SIDEBAR_STATE,
    payload: newState
  };
};